<template>
  <div
    class="pagoda-table-edit"
    :class="{
      'is-focus': hasElInstance && isFocus
    }"
    @keyup.left="_keyboadrHandler($event, 'left')"
    @keyup.right="_keyboadrHandler($event, 'right')"
    @keyup.up="_keyboadrHandler($event, 'up')"
    @keyup.down="_keyboadrHandler($event, 'down')"
    @keyup.enter.stop
  >
    <component
      :is="component"
      :value="value"
      :class="{
        'not-multiple': !config.multiple
      }"
      :prop="config.prop"
      v-bind="props"
      v-on="$listeners"
      @focus="_active"
      @component-blur="_editComponentBlur"
      ref="tableEditComponent"
    >
      <template :slot="$scopedSlots[`${config.prop}-slot`] || $slots[`${config.prop}-slot`] ? 'default' : null" slot-scope="scope">
        <slot :name="`${config.prop}-slot`" v-bind="scope" :input="$listeners.input"></slot>
      </template>
      <template slot-scope="scope" :slot="slotName" v-for="{slotKey, slotName} in _hasNameSlots">
        <slot :name="`${slotKey}__${slotName}`" v-bind="scope" :input="$listeners.input"></slot>
      </template>
      <el-option
        v-if="!$scopedSlots[`${config.prop}-slot`] && config.constraint === 'select'"
        v-for="option in config.options"
        :key="props['value-key'] || props.valueKey ? option.value[props['value-key'] || props.valueKey] : option.value"
        :label="option.label"
        :value="'value' in option ? option.value : option.label"
      >
      </el-option>
    </component>
    <div
      class="table-edit-focus-proxy-wrapper"
      :class="{
        'is-show': hasProxy
      }"
      @click.stop.prevent="_active"
    >
      <input
        type="text"
        :class="['table-edit-focus-proxy', `table-edit-focus-proxy--${props.size}`]"
        autocomplete="off"
        placeholder="请选择"
        readonly="readonly"
        :value="label || value"
        @blur="_blur"
        @keydown.up.prevent
        @keydown.down.prevent
        @keydown.enter.stop="_active"
        ref="focusProxy"
      />
      <span class="el-input__suffix">
        <span class="el-input__suffix-inner">
          <i class="el-select__caret el-input__icon" :class="icon"></i>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
  import './el-select-proxy'

  import {
    getEmptyObject
  } from "../../../../utils";

  import hasNameSlots from '../../../mixins/hasNameSlots'

  export default {
    name: 'TableEditItem',
    mixins: [hasNameSlots],
    props: {
      value: null,
      label: null,
      config: {
        type: Object,
        default: getEmptyObject
      },
      props: {
        type: Object,
        default: getEmptyObject
      }
    },
    created () {
      this.isTableEditItem = true
    },
    mounted () {
      this.$nextTick(() => {
        const vm = this

        this.focusProxy = this.$refs.focusProxy
        this.tableEditComponent = this.$refs.tableEditComponent

        this.ElInstance = this._getElInstance(this)
        this.hasElInstance = !!this.ElInstance
        this.ElInstanceType = this.hasElInstance && this.ElInstance.$options.name

        // 针对ElDatePicker 做一些事件触发的拦截
        if (this.ElInstanceType === 'ElDatePicker') {
          const oldMountPickerHandler = this.ElInstance.mountPicker
          const oldHandleKeydown = this.ElInstance.handleKeydown

          this.ElInstance.mountPicker = function (...arg) {
            const elDatePickerInstance = this
            oldMountPickerHandler.apply(elDatePickerInstance, arg)

            const oldHandleDatePick = elDatePickerInstance.picker.handleDatePick
            const oldConfrimHandler = elDatePickerInstance.picker.confirm
            const oldChangeToNowHandler = elDatePickerInstance.picker.changeToNow


            elDatePickerInstance.picker.handleDatePick = function (...arg) {
              oldHandleDatePick.apply(this, arg)

              if(vm.ElInstance.type === 'date'){
                vm._editComponentBlur()
              }
            }

            elDatePickerInstance.picker.confirm = function (...arg) {
              oldConfrimHandler.apply(this, arg)

              vm._editComponentBlur()
            }

            elDatePickerInstance.picker.changeToNow = function (...arg) {
              oldChangeToNowHandler.apply(this, arg)

              vm._editComponentBlur()
            }
          }

          this.ElInstance.handleKeydown = function (...arg) {
            oldHandleKeydown.apply(this, arg)

            const event = arg[0]

            if(event.keyCode === 13){
              vm._editComponentBlur()
            }
          }
        }
      })
    },
    data () {
      return {
        isActive: false,
        isFocus: false,
        hasElInstance: false
      }
    },
    computed: {
      _hasNameSlots () {
        return this.hasNameSlots.filter(({slotKey}) => slotKey === this.config.prop)
      },
      component () {
        const { $$components } = this.$options

        try {
          return $$components[this.config.constraint].component
        } catch (e) {
          console.error(`table中${this.config.constraint}组件未注册`)
        }
      },
      icon () {
        return 'el-icon-setting'
      },
      hasProxy () {
        const { $$components } = this.$options

        try {
          return !!$$components[this.config.constraint].proxy
        } catch (e) {
          console.error(`table中${this.config.constraint}组件未注册`)
        }
      }
    },
    methods: {
      _keyboadrHandler(e, type) {
        if(this.ElInstanceType === 'ElSelect' && (type === 'up' || type === 'down') && this.isActive){
          e.stopPropagation()
        }else if(this.ElInstanceType === 'ElDatePicker' && this.isActive){
          e.stopPropagation()
        }else{
          this._editComponentBlur()
        }
      },
      _getElInstance (instance) {
        const instances = instance.$children

        for(let i = 0; i < instances.length; i++){
          const _instance = instances[i]

          if(_instance.$options.name && _instance.$options.name.includes('El')){
            return _instance
          }else{
            return this._getElInstance(_instance)
          }
        }
      },
      _editComponentBlur () {
        // 解决ElSelect 失焦时不隐藏菜单
        if(this.ElInstanceType === 'ElSelect') {
          this.ElInstance.visible = false
        // 解决ElDatePicker 失焦时不隐藏菜单
        }else if(this.ElInstanceType === 'ElDatePicker'){
          this.ElInstance.pickerVisible = false
        }

        this.isActive = false
        this.focus()
      },
      _active (e) {
        this.tableEditComponent.focus && this.tableEditComponent.focus()

        // 解决element-ui 2.3.x 版本后select focus方法不展开菜单的hack
        if(e.keyCode === 13 && this.ElInstanceType === 'ElSelect'){
          this.ElInstance.visible = true
        }

        this.focusProxy.blur()
        this.isActive = true
      },
      _blur () {
        this.isFocus = false
      },
      focus () {
        this.focusProxy.focus()
        this.isFocus = true
      }
    }
  }
</script>
